import { INSTRUCTIONAL_MODES } from "./journeyInstructionalModes";

const { I_DO, WE_DO, YOU_DO } = INSTRUCTIONAL_MODES;

/**
 * Pedagogical responsibility crosswalk for Summer Camp Journeys and STEM Missions.
 *
 * The assignment is explicit at block level. It is intentionally separate
 * from student response state and does not change block IDs, save_as keys,
 * completion rules, assets, or Saras context.
 */
export const JOURNEY_INSTRUCTIONAL_MODE_ASSIGNMENTS = {
  "electric-spiral": {
    "breeze-station-silent": {
      "station-alert": "I_DO",
      "station-reveal": "I_DO",
      "two-kits-gallery": "WE_DO",
      "opening-cause": "YOU_DO",
      "opening-record": "YOU_DO",
      "step1-saras": "YOU_DO",
      "step1-completion": "YOU_DO"
    },
    "invisible-power-path": {
      "path-story": "I_DO",
      "path-gallery": "WE_DO",
      "loop-sequence": "WE_DO",
      "gap-prediction": "YOU_DO",
      "switch-check": "YOU_DO",
      "loop-explanation": "YOU_DO",
      "step2-saras": "YOU_DO",
      "step2-completion": "YOU_DO"
    },
    "light-the-signal-beacon": {
      "parta-story": "I_DO",
      "parta-gallery": "I_DO",
      "parta-readiness": "WE_DO",
      "parta-build": "WE_DO",
      "parta-trial": "YOU_DO",
      "parta-check": "YOU_DO",
      "step3-saras": "YOU_DO",
      "step3-completion": "YOU_DO"
    },
    "one-loop-two-jobs": {
      "bridge-story": "I_DO",
      "same-different": "WE_DO",
      "comparison-gallery": "WE_DO",
      "parta-chain": "WE_DO",
      "power-loop-video": "WE_DO",
      "partb-predicted-chain": "YOU_DO",
      "bridge-explanation": "YOU_DO",
      "step4-saras": "YOU_DO",
      "step4-completion": "YOU_DO"
    },
    "meet-the-wind-engine": {
      "partb-reveal-story": "I_DO",
      "partb-mainmenu": "WE_DO",
      "partb-materials": "WE_DO",
      "partb-gallery": "WE_DO",
      "component-jobs": "WE_DO",
      "component-explanation": "YOU_DO",
      "step5-saras": "YOU_DO",
      "step5-completion": "YOU_DO"
    },
    "build-the-breeze-tower": {
      "tower-story": "I_DO",
      "assembly-gallery": "I_DO",
      "assembly-pwo": "I_DO",
      "partb-safety": "WE_DO",
      "partb-build": "WE_DO",
      "assembly-risk": "YOU_DO",
      "assembly-note": "YOU_DO",
      "step6-saras": "YOU_DO",
      "step6-completion": "YOU_DO"
    },
    "wake-the-wind-engine": {
      "wake-story": "I_DO",
      "test-gallery": "WE_DO",
      "first-run-checklist": "WE_DO",
      "learned-pwo": "WE_DO",
      "first-run-prediction": "YOU_DO",
      "first-run-record": "YOU_DO",
      "wind-chain": "YOU_DO",
      "step7-saras": "YOU_DO",
      "step7-completion": "YOU_DO"
    },
    "backward-breeze-mystery": {
      "reverse-story": "I_DO",
      "reverse-gallery": "WE_DO",
      "fair-test-plan": "WE_DO",
      "direction-safety": "WE_DO",
      "reverse-prediction": "YOU_DO",
      "direction-record": "YOU_DO",
      "reverse-check": "YOU_DO",
      "direction-video": "YOU_DO",
      "step8-saras": "YOU_DO",
      "step8-completion": "YOU_DO"
    },
    "rescue-the-engine": {
      "rescue-story": "I_DO",
      "troubleshoot-gallery": "I_DO",
      "fault-classification": "WE_DO",
      "diagnostic-sequence": "WE_DO",
      "trial1-summary": "YOU_DO",
      "fault-hypothesis": "YOU_DO",
      "redesign-record": "YOU_DO",
      "diagnostics-video": "YOU_DO",
      "safety-quiz": "YOU_DO",
      "step9-saras": "YOU_DO",
      "step9-completion": "YOU_DO"
    },
    "wind-engine-report": {
      "final-story": "I_DO",
      "final-gallery": "WE_DO",
      "prior-evidence": "YOU_DO",
      "final-chain": "YOU_DO",
      "final-honesty": "YOU_DO",
      "engineer-report": "YOU_DO",
      "final-reflection": "YOU_DO",
      "step10-saras": "YOU_DO",
      "step10-completion": "YOU_DO"
    }
  },
  "wind-powered-car": {
    "green-valley-rescue": {
      "rescue-alert": "I_DO",
      "rescue-image": "WE_DO",
      "solution-prediction": "YOU_DO",
      "initial-theory": "YOU_DO",
      "step1-saras": "YOU_DO",
      "step1-completion": "YOU_DO"
    },
    "mystery-rover": {
      "step2-story": "I_DO",
      "rover-image-gallery": "WE_DO",
      "mainmenu-pwo-block": "WE_DO",
      "rover-observations": "WE_DO",
      "science-rover-video-block": "WE_DO",
      "motion-source": "YOU_DO",
      "motor-job-check": "YOU_DO",
      "step2-explanation": "YOU_DO",
      "step2-saras": "YOU_DO",
      "step2-completion": "YOU_DO"
    },
    "trace-the-power-path": {
      "step3-story": "I_DO",
      "accessories-pwo-block": "WE_DO",
      "parts-gallery": "WE_DO",
      "parts-found": "WE_DO",
      "component-jobs": "WE_DO",
      "system-video-block": "WE_DO",
      "power-path": "YOU_DO",
      "closed-circuit-check": "YOU_DO",
      "power-explanation": "YOU_DO",
      "step3-saras": "YOU_DO",
      "step3-completion": "YOU_DO"
    },
    "backward-push-mystery": {
      "step4-story": "I_DO",
      "air-diagram": "WE_DO",
      "backward-push-video-block": "WE_DO",
      "balloon-pwo-block": "WE_DO",
      "air-prediction": "YOU_DO",
      "demo-observation": "YOU_DO",
      "thrust-check": "YOU_DO",
      "reverse-wire-check": "YOU_DO",
      "backward-explanation": "YOU_DO",
      "step4-saras": "YOU_DO",
      "step4-completion": "YOU_DO"
    },
    "build-readiness": {
      "step5-story": "I_DO",
      "readiness-gallery": "I_DO",
      "parts-readiness": "WE_DO",
      "safety-checks": "WE_DO",
      "failure-prediction": "YOU_DO",
      "build-plan-note": "YOU_DO",
      "step5-saras": "YOU_DO",
      "step5-completion": "YOU_DO"
    },
    "assemble-rescue-rover": {
      "step6-story": "I_DO",
      "installation-pwo-block": "I_DO",
      "installation-gallery": "I_DO",
      "assembly-checklist": "WE_DO",
      "wheel-check": "WE_DO",
      "power-off-confirm": "YOU_DO",
      "assembly-note": "YOU_DO",
      "step6-saras": "YOU_DO",
      "step6-completion": "YOU_DO"
    },
    "first-spin-diagnostic": {
      "step7-story": "I_DO",
      "diagnostic-image": "WE_DO",
      "first-spin-record": "WE_DO",
      "build-summary": "YOU_DO",
      "open-circuit-diagnostic": "YOU_DO",
      "diagnostic-note": "YOU_DO",
      "step7-saras": "YOU_DO",
      "step7-completion": "YOU_DO"
    },
    "first-rescue-run": {
      "step8-story": "I_DO",
      "lane-image": "WE_DO",
      "trial-prior-work": "YOU_DO",
      "trial1-prediction": "YOU_DO",
      "trial1-record": "YOU_DO",
      "friction-video-block": "YOU_DO",
      "friction-check": "YOU_DO",
      "trial1-observation": "YOU_DO",
      "first-run-problem": "YOU_DO",
      "step8-saras": "YOU_DO",
      "step8-completion": "YOU_DO"
    },
    "engineer-version-two": {
      "step9-story": "I_DO",
      "fair-test-image": "WE_DO",
      "trial1-summary": "YOU_DO",
      "redesign-variable": "YOU_DO",
      "redesign-prediction": "YOU_DO",
      "taming-thrust-video-block": "YOU_DO",
      "trial2-record": "YOU_DO",
      "comparison-claim": "YOU_DO",
      "redesign-conclusion": "YOU_DO",
      "step9-saras": "YOU_DO",
      "step9-completion": "YOU_DO"
    },
    "engineers-rescue-report": {
      "step10-story": "I_DO",
      "final-chain-image": "WE_DO",
      "final-prior-work": "YOU_DO",
      "final-energy-chain": "YOU_DO",
      "honesty-check": "YOU_DO",
      "engineer-report": "YOU_DO",
      "real-wind-video-block": "YOU_DO",
      "final-reflection": "YOU_DO",
      "step10-saras": "YOU_DO",
      "step10-completion": "YOU_DO"
    }
  },
  "wind-powered-car-mission": {
    "wind-car-prelude": {
      "green-valley-story-prelude": "I_DO",
      "rescue-alert": "I_DO",
      "rescue-image": "WE_DO",
      "prelude-completion": "YOU_DO"
    },
    "wind-car-wonder": {
      "solution-prediction": "YOU_DO",
      "initial-theory": "YOU_DO",
      "step1-saras": "YOU_DO",
      "wonder-completion": "YOU_DO"
    },
    "wind-car-explore": {
      "step2-story": "I_DO",
      "rover-image-gallery": "WE_DO",
      "mainmenu-pwo-block": "WE_DO",
      "rover-observations": "WE_DO",
      "motion-source": "YOU_DO",
      "science-rover-video-block": "WE_DO",
      "motor-job-check": "YOU_DO",
      "step2-explanation": "YOU_DO",
      "step2-saras": "YOU_DO",
      "explore-completion": "YOU_DO"
    },
    "wind-car-understand": {
      "step3-story": "I_DO",
      "accessories-pwo-block": "WE_DO",
      "parts-gallery": "WE_DO",
      "parts-found": "WE_DO",
      "component-jobs": "WE_DO",
      "system-video-block": "WE_DO",
      "power-path": "YOU_DO",
      "closed-circuit-check": "YOU_DO",
      "power-explanation": "YOU_DO",
      "step3-saras": "YOU_DO",
      "step4-story": "I_DO",
      "air-diagram": "WE_DO",
      "air-prediction": "YOU_DO",
      "backward-push-video-block": "WE_DO",
      "balloon-pwo-block": "WE_DO",
      "demo-observation": "YOU_DO",
      "thrust-check": "YOU_DO",
      "reverse-wire-check": "YOU_DO",
      "backward-explanation": "YOU_DO",
      "step4-saras": "YOU_DO",
      "understand-completion": "YOU_DO"
    },
    "wind-car-apply": {
      "step5-story": "I_DO",
      "readiness-gallery": "I_DO",
      "parts-readiness": "WE_DO",
      "safety-checks": "WE_DO",
      "failure-prediction": "YOU_DO",
      "build-plan-note": "YOU_DO",
      "step5-saras": "YOU_DO",
      "step6-story": "I_DO",
      "installation-pwo-block": "I_DO",
      "installation-gallery": "I_DO",
      "assembly-checklist": "WE_DO",
      "wheel-check": "WE_DO",
      "power-off-confirm": "YOU_DO",
      "assembly-note": "YOU_DO",
      "step6-saras": "YOU_DO",
      "apply-completion": "YOU_DO"
    },
    "wind-car-test-improve": {
      "step7-story": "I_DO",
      "diagnostic-image": "WE_DO",
      "build-summary": "YOU_DO",
      "first-spin-record": "WE_DO",
      "open-circuit-diagnostic": "YOU_DO",
      "diagnostic-note": "YOU_DO",
      "step7-saras": "YOU_DO",
      "step8-story": "I_DO",
      "lane-image": "WE_DO",
      "trial-prior-work": "YOU_DO",
      "trial1-prediction": "YOU_DO",
      "trial1-record": "YOU_DO",
      "friction-video-block": "YOU_DO",
      "friction-check": "YOU_DO",
      "trial1-observation": "YOU_DO",
      "first-run-problem": "YOU_DO",
      "step8-saras": "YOU_DO",
      "step9-story": "I_DO",
      "fair-test-image": "WE_DO",
      "trial1-summary": "YOU_DO",
      "redesign-variable": "YOU_DO",
      "redesign-prediction": "YOU_DO",
      "taming-thrust-video-block": "YOU_DO",
      "trial2-record": "YOU_DO",
      "comparison-claim": "YOU_DO",
      "redesign-conclusion": "YOU_DO",
      "step9-saras": "YOU_DO",
      "test-improve-completion": "YOU_DO"
    },
    "wind-car-explain": {
      "step10-story": "I_DO",
      "final-chain-image": "WE_DO",
      "final-prior-work": "YOU_DO",
      "final-energy-chain": "YOU_DO",
      "engineer-report": "YOU_DO",
      "step10-saras": "YOU_DO",
      "explain-completion": "YOU_DO"
    },
    "wind-car-reflect": {
      "reflect-story": "I_DO",
      "reflect-prior-work": "YOU_DO",
      "final-reflection": "YOU_DO",
      "reflect-completion": "YOU_DO"
    },
    "wind-car-grow": {
      "grow-story": "I_DO",
      "real-wind-video-block": "YOU_DO",
      "honesty-check": "YOU_DO",
      "grow-saras": "YOU_DO",
      "grow-completion": "YOU_DO",
      "after-camp-green-valley-mission": "YOU_DO",
      "after-camp-green-valley-choice": "YOU_DO",
      "after-camp-green-valley-plan": "YOU_DO",
      "after-camp-green-valley-safety": "YOU_DO",
      "after-camp-green-valley-trials": "YOU_DO",
      "after-camp-green-valley-conclusion": "YOU_DO",
      "after-camp-green-valley-saras": "YOU_DO"
    }
  },
  "conductive-dough": {
    "glow-city-blackout": {
      "blackout-alert": "I_DO",
      "blackout-reveal": "I_DO",
      "evidence-gallery": "WE_DO",
      "opening-cause": "YOU_DO",
      "opening-observations": "YOU_DO",
      "step1-saras": "YOU_DO",
      "step1-completion": "YOU_DO"
    },
    "squishy-road-secret": {
      "step2-story": "I_DO",
      "mainmenu-pwo": "WE_DO",
      "materials-pwo": "WE_DO",
      "material-gallery": "WE_DO",
      "material-jobs": "WE_DO",
      "material-prediction": "YOU_DO",
      "road-explanation": "YOU_DO",
      "step2-saras": "YOU_DO",
      "step2-completion": "YOU_DO"
    },
    "build-two-power-roads": {
      "step3-story": "I_DO",
      "step1-pwo": "WE_DO",
      "step2-pwo": "WE_DO",
      "two-road-gallery": "WE_DO",
      "loop-sequence": "WE_DO",
      "two-road-prediction": "YOU_DO",
      "gap-reason": "YOU_DO",
      "step3-saras": "YOU_DO",
      "step3-completion": "YOU_DO"
    },
    "one-way-light-gate": {
      "step4-story": "I_DO",
      "polarity-gallery": "WE_DO",
      "step3-pwo": "WE_DO",
      "step4-pwo": "WE_DO",
      "dark-led-video": "WE_DO",
      "polarity-prediction": "YOU_DO",
      "polarity-record": "YOU_DO",
      "polarity-check": "YOU_DO",
      "step4-saras": "YOU_DO",
      "step4-completion": "YOU_DO"
    },
    "first-glow-bridge": {
      "step5-story": "I_DO",
      "kit-gallery": "I_DO",
      "assembly-pwo": "I_DO",
      "kit-inventory": "WE_DO",
      "physical-safety": "WE_DO",
      "first-light-build": "WE_DO",
      "first-light-record": "YOU_DO",
      "step5-saras": "YOU_DO",
      "step5-completion": "YOU_DO"
    },
    "shortcut-thief": {
      "step6-story": "I_DO",
      "shortcut-gallery": "WE_DO",
      "short-video": "WE_DO",
      "fault-classification": "WE_DO",
      "shortcut-prediction": "YOU_DO",
      "shortcut-sequence": "YOU_DO",
      "safe-short-fix": "YOU_DO",
      "step6-saras": "YOU_DO",
      "step6-completion": "YOU_DO"
    },
    "wall-saves-light": {
      "step7-story": "I_DO",
      "wall-gallery": "WE_DO",
      "exploremore-pwo": "WE_DO",
      "wall-jobs": "WE_DO",
      "wall-build-check": "WE_DO",
      "wall-placement": "YOU_DO",
      "wall-comparison": "YOU_DO",
      "step7-saras": "YOU_DO",
      "step7-completion": "YOU_DO"
    },
    "design-glow-landmark": {
      "step8-story": "I_DO",
      "landmark-gallery": "WE_DO",
      "criteria-constraints": "WE_DO",
      "landmark-type": "YOU_DO",
      "design-plan": "YOU_DO",
      "landmark-build": "YOU_DO",
      "landmark-first-trial": "YOU_DO",
      "step8-saras": "YOU_DO",
      "step8-completion": "YOU_DO"
    },
    "rescue-dark-sculpture": {
      "step9-story": "I_DO",
      "troubleshooting-image": "I_DO",
      "fault-hypothesis": "WE_DO",
      "trial1-summary": "YOU_DO",
      "redesign-variable": "YOU_DO",
      "redesign-prediction": "YOU_DO",
      "trial2-record": "YOU_DO",
      "redesign-conclusion": "YOU_DO",
      "step9-saras": "YOU_DO",
      "step9-completion": "YOU_DO"
    },
    "light-up-glow-city": {
      "step10-story": "I_DO",
      "final-gallery": "WE_DO",
      "prior-evidence": "YOU_DO",
      "final-chain": "YOU_DO",
      "honesty-check": "YOU_DO",
      "rescue-report": "YOU_DO",
      "final-reflection": "YOU_DO",
      "step10-saras": "YOU_DO",
      "step10-completion": "YOU_DO"
    }
  },
  "mystery-of-the-robot-artist": {
    "accept-the-challenge": {
      "case-update": "I_DO",
      "robot-reveal": "I_DO",
      "robot-abilities": "WE_DO",
      "criteria-constraints": "WE_DO",
      "engineering-video": "WE_DO",
      "meet-robot-pwo": "WE_DO",
      "theory-comparison": "YOU_DO",
      "clue-now-makes-sense": "YOU_DO",
      "mission-goal": "YOU_DO",
      "mission-saras": "YOU_DO",
      "step2-completion": "YOU_DO"
    },
    "investigate-the-kit": {
      "step3-story": "I_DO",
      "accessories-pwo": "WE_DO",
      "kit-evidence-gallery": "WE_DO",
      "real-kit-check": "WE_DO",
      "part-systems": "WE_DO",
      "part-jobs": "WE_DO",
      "mystery-weight-hypothesis": "YOU_DO",
      "mystery-weight-reason": "YOU_DO",
      "student-kit-question": "YOU_DO",
      "kit-saras": "YOU_DO",
      "step3-completion": "YOU_DO"
    },
    "plan-the-robot": {
      "step4-story": "I_DO",
      "energy-evidence-gallery": "WE_DO",
      "energy-intro-video": "WE_DO",
      "energy-forms-pwo": "WE_DO",
      "battery-pwo": "WE_DO",
      "energy-pathway": "WE_DO",
      "system-energy-jobs": "WE_DO",
      "energy-start-prediction": "YOU_DO",
      "motor-energy-check": "YOU_DO",
      "motion-plan": "YOU_DO",
      "art-pattern-plan": "YOU_DO",
      "power-plan-evidence": "YOU_DO",
      "step4-saras": "YOU_DO",
      "step4-completion": "YOU_DO"
    },
    "build-the-circuit": {
      "step5-story": "I_DO",
      "circuit-images": "WE_DO",
      "circuit-video": "WE_DO",
      "closed-switch-pwo": "WE_DO",
      "circuit-path-sequence": "WE_DO",
      "circuit-jobs": "WE_DO",
      "physical-circuit-checklist": "WE_DO",
      "circuit-first-prediction": "YOU_DO",
      "open-wire-check": "YOU_DO",
      "circuit-evidence": "YOU_DO",
      "step5-saras": "YOU_DO",
      "step5-completion": "YOU_DO"
    },
    "create-the-vibration": {
      "step6-story": "I_DO",
      "wobble-images": "WE_DO",
      "dancing-robot-video": "WE_DO",
      "motor-animation-pwo": "WE_DO",
      "inertia-pwo": "WE_DO",
      "wobble-sequence": "WE_DO",
      "motion-causes": "WE_DO",
      "balanced-offcenter-prediction": "YOU_DO",
      "center-weight-check": "YOU_DO",
      "wobble-evidence": "YOU_DO",
      "step6-saras": "YOU_DO",
      "step6-completion": "YOU_DO"
    },
    "first-art-test": {
      "step7-story": "I_DO",
      "assembly-gallery": "I_DO",
      "assembly-video": "I_DO",
      "installation-pwo": "I_DO",
      "assembly-phase-checklist": "WE_DO",
      "mapping-wobble-video": "WE_DO",
      "launch-prediction": "YOU_DO",
      "first-test-record": "YOU_DO",
      "drawing-as-data": "YOU_DO",
      "step7-saras": "YOU_DO",
      "step7-completion": "YOU_DO"
    },
    "engineering-improvement": {
      "step8-story": "I_DO",
      "redesign-gallery": "WE_DO",
      "redesign-video": "WE_DO",
      "test1-case-file": "YOU_DO",
      "redesign-variable": "YOU_DO",
      "redesign-prediction": "YOU_DO",
      "wobble-power-video": "YOU_DO",
      "friction-station": "YOU_DO",
      "test2-record": "YOU_DO",
      "improvement-conclusion": "YOU_DO",
      "test-comparison": "YOU_DO",
      "step8-saras": "YOU_DO",
      "step8-completion": "YOU_DO"
    },
    "explain-the-science": {
      "step9-story": "I_DO",
      "system-gallery": "WE_DO",
      "tests-summary": "YOU_DO",
      "energy-motion-sequence": "YOU_DO",
      "system-jobs": "YOU_DO",
      "imbalance-recap-video": "YOU_DO",
      "circuit-recap-video": "YOU_DO",
      "circuit-defense": "YOU_DO",
      "motion-defense": "YOU_DO",
      "final-science-explanation": "YOU_DO",
      "evidence-for-explanation": "YOU_DO",
      "step9-saras": "YOU_DO",
      "step9-completion": "YOU_DO"
    },
    "robot-art-gallery": {
      "step10-story": "I_DO",
      "gallery-images": "WE_DO",
      "final-case-summary": "YOU_DO",
      "robot-name": "YOU_DO",
      "artwork-title": "YOU_DO",
      "gallery-piece": "YOU_DO",
      "gallery-presentation": "YOU_DO",
      "engineers-defense": "YOU_DO",
      "completion-pwo": "YOU_DO",
      "final-reflection": "YOU_DO",
      "step10-saras": "YOU_DO",
      "step10-completion": "YOU_DO"
    }
  },
  "flood-rescue-bridge": {
    "flood-rescue-prelude": {
      "flood-rescue-story-prelude": "I_DO",
      "mission-fact-check": "YOU_DO",
      "prelude-saras": "YOU_DO",
      "prelude-completion": "YOU_DO"
    },
    "rescue-prediction": {
      "wonder-story": "I_DO",
      "bridge1-capacity-prediction": "YOU_DO",
      "wonder-saras": "YOU_DO",
      "wonder-completion": "YOU_DO"
    },
    "flat-bridge-test": {
      "explore-story": "I_DO",
      "baseline-checklist": "WE_DO",
      "bridge1-record": "YOU_DO",
      "bridge1-observation": "YOU_DO",
      "explore-saras": "YOU_DO",
      "explore-completion": "YOU_DO"
    },
    "hidden-forces": {
      "bridge1-prior-evidence": "YOU_DO",
      "invisible-forces-video": "WE_DO",
      "force-check": "YOU_DO",
      "same-paper-shape-video": "WE_DO",
      "bridge1-science-explanation": "YOU_DO",
      "understand-saras": "YOU_DO",
      "understand-completion": "YOU_DO"
    },
    "engineer-bridge-two": {
      "apply-story": "I_DO",
      "design-change": "YOU_DO",
      "design-prediction": "YOU_DO",
      "apply-saras": "YOU_DO",
      "apply-completion": "YOU_DO"
    },
    "fair-rescue-test": {
      "fair-test-video": "WE_DO",
      "trial1-summary": "YOU_DO",
      "fair-test-checklist": "WE_DO",
      "bridge2-record": "YOU_DO",
      "comparison-claim": "YOU_DO",
      "test-saras": "YOU_DO",
      "test-completion": "YOU_DO"
    },
    "young-engineer-report": {
      "failure-clues-video": "WE_DO",
      "report-prior-work": "YOU_DO",
      "first-failure-explanation": "YOU_DO",
      "change-explanation": "YOU_DO",
      "evidence-defense": "YOU_DO",
      "report-saras": "YOU_DO",
      "report-completion": "YOU_DO"
    },
    "evidence-reflection": {
      "reflection-prior-work": "YOU_DO",
      "thinking-change": "YOU_DO",
      "failure-learning": "YOU_DO",
      "reflect-saras": "YOU_DO",
      "reflect-completion": "YOU_DO"
    },
    "next-variable-mission": {
      "real-bridges-video": "WE_DO",
      "next-variable-choice": "YOU_DO",
      "next-test-plan": "YOU_DO",
      "grow-saras": "YOU_DO",
      "grow-completion": "YOU_DO"
    }
  },
"electric-spiral-mission": {
    "electric-spiral-prelude": {
      "breeze-station-story-prelude": "I_DO",
      "station-alert": "I_DO",
      "station-reveal": "I_DO",
      "two-kits-gallery": "WE_DO",
      "electric-prelude-completion": "YOU_DO"
    },
    "electric-spiral-wonder": {
      "opening-cause": "YOU_DO",
      "opening-record": "YOU_DO",
      "step1-saras": "YOU_DO",
      "electric-wonder-completion": "YOU_DO"
    },
    "electric-spiral-explore": {
      "path-story": "I_DO",
      "gap-prediction": "YOU_DO",
      "path-gallery": "WE_DO",
      "loop-sequence": "WE_DO",
      "switch-check": "YOU_DO",
      "loop-explanation": "YOU_DO",
      "step2-saras": "YOU_DO",
      "parta-story": "I_DO",
      "parta-gallery": "I_DO",
      "parta-readiness": "WE_DO",
      "parta-build": "WE_DO",
      "parta-trial": "YOU_DO",
      "parta-check": "YOU_DO",
      "step3-saras": "YOU_DO",
      "electric-explore-completion": "YOU_DO"
    },
    "electric-spiral-understand": {
      "bridge-story": "I_DO",
      "same-different": "WE_DO",
      "comparison-gallery": "WE_DO",
      "parta-chain": "WE_DO",
      "partb-predicted-chain": "YOU_DO",
      "power-loop-video": "WE_DO",
      "bridge-explanation": "YOU_DO",
      "step4-saras": "YOU_DO",
      "partb-reveal-story": "I_DO",
      "partb-mainmenu": "WE_DO",
      "partb-materials": "WE_DO",
      "partb-gallery": "WE_DO",
      "component-jobs": "WE_DO",
      "component-explanation": "YOU_DO",
      "step5-saras": "YOU_DO",
      "electric-understand-completion": "YOU_DO"
    },
    "electric-spiral-apply": {
      "tower-story": "I_DO",
      "assembly-gallery": "I_DO",
      "assembly-pwo": "I_DO",
      "partb-safety": "WE_DO",
      "partb-build": "WE_DO",
      "assembly-risk": "YOU_DO",
      "assembly-note": "YOU_DO",
      "step6-saras": "YOU_DO",
      "electric-apply-completion": "YOU_DO"
    },
    "electric-spiral-test-improve": {
      "wake-story": "I_DO",
      "test-gallery": "WE_DO",
      "first-run-prediction": "YOU_DO",
      "first-run-checklist": "WE_DO",
      "first-run-record": "YOU_DO",
      "wind-chain": "YOU_DO",
      "learned-pwo": "WE_DO",
      "step7-saras": "YOU_DO",
      "reverse-story": "I_DO",
      "reverse-gallery": "WE_DO",
      "reverse-prediction": "YOU_DO",
      "fair-test-plan": "WE_DO",
      "direction-safety": "WE_DO",
      "direction-record": "YOU_DO",
      "reverse-check": "YOU_DO",
      "direction-video": "YOU_DO",
      "step8-saras": "YOU_DO",
      "rescue-story": "I_DO",
      "troubleshoot-gallery": "I_DO",
      "fault-classification": "WE_DO",
      "diagnostic-sequence": "WE_DO",
      "trial1-summary": "YOU_DO",
      "fault-hypothesis": "YOU_DO",
      "redesign-record": "YOU_DO",
      "diagnostics-video": "YOU_DO",
      "safety-quiz": "YOU_DO",
      "step9-saras": "YOU_DO",
      "electric-test-improve-completion": "YOU_DO"
    },
    "electric-spiral-explain": {
      "final-story": "I_DO",
      "final-gallery": "WE_DO",
      "prior-evidence": "YOU_DO",
      "final-chain": "YOU_DO",
      "final-honesty": "YOU_DO",
      "engineer-report": "YOU_DO",
      "step10-saras": "YOU_DO",
      "electric-explain-completion": "YOU_DO"
    },
    "electric-spiral-reflect": {
      "electric-reflect-story": "I_DO",
      "final-reflection": "YOU_DO",
      "electric-reflect-completion": "YOU_DO"
    },
    "electric-spiral-grow": {
      "electric-grow-story": "I_DO",
      "electric-grow-transfer": "YOU_DO",
      "electric-grow-saras": "YOU_DO",
      "electric-grow-completion": "YOU_DO"
    }
  },
  "conductive-dough-mission": {
    "conductive-dough-prelude": {
      "glow-city-story-prelude": "I_DO",
      "blackout-alert": "I_DO",
      "blackout-reveal": "I_DO",
      "evidence-gallery": "WE_DO",
      "conductive-prelude-completion": "YOU_DO"
    },
    "conductive-dough-wonder": {
      "opening-cause": "YOU_DO",
      "opening-observations": "YOU_DO",
      "step1-saras": "YOU_DO",
      "conductive-wonder-completion": "YOU_DO"
    },
    "conductive-dough-explore": {
      "step2-story": "I_DO",
      "material-prediction": "YOU_DO",
      "mainmenu-pwo": "WE_DO",
      "materials-pwo": "WE_DO",
      "material-gallery": "WE_DO",
      "material-jobs": "WE_DO",
      "road-explanation": "YOU_DO",
      "step2-saras": "YOU_DO",
      "step3-story": "I_DO",
      "two-road-prediction": "YOU_DO",
      "step1-pwo": "WE_DO",
      "step2-pwo": "WE_DO",
      "two-road-gallery": "WE_DO",
      "loop-sequence": "WE_DO",
      "gap-reason": "YOU_DO",
      "step3-saras": "YOU_DO",
      "conductive-explore-completion": "YOU_DO"
    },
    "conductive-dough-understand": {
      "step4-story": "I_DO",
      "polarity-prediction": "YOU_DO",
      "polarity-gallery": "WE_DO",
      "step3-pwo": "WE_DO",
      "step4-pwo": "WE_DO",
      "dark-led-video": "WE_DO",
      "polarity-record": "YOU_DO",
      "polarity-check": "YOU_DO",
      "step4-saras": "YOU_DO",
      "conductive-understand-completion": "YOU_DO"
    },
    "conductive-dough-apply": {
      "step5-story": "I_DO",
      "kit-gallery": "I_DO",
      "assembly-pwo": "I_DO",
      "kit-inventory": "WE_DO",
      "physical-safety": "WE_DO",
      "first-light-build": "WE_DO",
      "first-light-record": "YOU_DO",
      "step5-saras": "YOU_DO",
      "conductive-apply-completion": "YOU_DO"
    },
    "conductive-dough-test-improve": {
      "step6-story": "I_DO",
      "shortcut-prediction": "YOU_DO",
      "shortcut-gallery": "WE_DO",
      "short-video": "WE_DO",
      "fault-classification": "WE_DO",
      "shortcut-sequence": "YOU_DO",
      "safe-short-fix": "YOU_DO",
      "step6-saras": "YOU_DO",
      "step7-story": "I_DO",
      "wall-placement": "YOU_DO",
      "wall-gallery": "WE_DO",
      "exploremore-pwo": "WE_DO",
      "wall-jobs": "WE_DO",
      "wall-build-check": "WE_DO",
      "wall-comparison": "YOU_DO",
      "step7-saras": "YOU_DO",
      "step8-story": "I_DO",
      "landmark-gallery": "WE_DO",
      "landmark-type": "YOU_DO",
      "criteria-constraints": "WE_DO",
      "design-plan": "YOU_DO",
      "landmark-build": "YOU_DO",
      "landmark-first-trial": "YOU_DO",
      "step8-saras": "YOU_DO",
      "step9-story": "I_DO",
      "troubleshooting-image": "I_DO",
      "trial1-summary": "YOU_DO",
      "fault-hypothesis": "WE_DO",
      "redesign-variable": "YOU_DO",
      "redesign-prediction": "YOU_DO",
      "trial2-record": "YOU_DO",
      "redesign-conclusion": "YOU_DO",
      "step9-saras": "YOU_DO",
      "conductive-test-improve-completion": "YOU_DO"
    },
    "conductive-dough-explain": {
      "step10-story": "I_DO",
      "final-gallery": "WE_DO",
      "prior-evidence": "YOU_DO",
      "final-chain": "YOU_DO",
      "honesty-check": "YOU_DO",
      "rescue-report": "YOU_DO",
      "step10-saras": "YOU_DO",
      "conductive-explain-completion": "YOU_DO"
    },
    "conductive-dough-reflect": {
      "conductive-reflect-story": "I_DO",
      "final-reflection": "YOU_DO",
      "conductive-reflect-completion": "YOU_DO"
    },
    "conductive-dough-grow": {
      "conductive-grow-story": "I_DO",
      "conductive-grow-transfer": "YOU_DO",
      "conductive-grow-saras": "YOU_DO",
      "conductive-grow-completion": "YOU_DO",
      "after-camp-glow-city-mission": "YOU_DO",
      "after-camp-mission-choice": "YOU_DO",
      "after-camp-plan": "YOU_DO",
      "after-camp-safety-check": "YOU_DO",
      "after-camp-three-trials": "YOU_DO",
      "after-camp-evidence-conclusion": "YOU_DO",
      "after-camp-saras": "YOU_DO"
    }
  },
  "robot-artist-mission": {
    "robot-artist-prelude": {
      "robot-artist-story-prelude": "I_DO",
      "robot-prelude-rule-check": "YOU_DO",
      "robot-prelude-completion": "YOU_DO"
    },
    "robot-artist-wonder": {
      "case-update": "I_DO",
      "robot-reveal": "I_DO",
      "theory-comparison": "YOU_DO",
      "clue-now-makes-sense": "YOU_DO",
      "robot-abilities": "WE_DO",
      "criteria-constraints": "WE_DO",
      "mission-goal": "YOU_DO",
      "engineering-video": "WE_DO",
      "meet-robot-pwo": "WE_DO",
      "mission-saras": "YOU_DO",
      "robot-wonder-completion": "YOU_DO"
    },
    "robot-artist-explore": {
      "step3-story": "I_DO",
      "accessories-pwo": "WE_DO",
      "kit-evidence-gallery": "WE_DO",
      "real-kit-check": "WE_DO",
      "part-systems": "WE_DO",
      "part-jobs": "WE_DO",
      "mystery-weight-hypothesis": "YOU_DO",
      "mystery-weight-reason": "YOU_DO",
      "student-kit-question": "YOU_DO",
      "kit-saras": "YOU_DO",
      "robot-explore-completion": "YOU_DO"
    },
    "robot-artist-understand": {
      "step4-story": "I_DO",
      "energy-start-prediction": "YOU_DO",
      "energy-evidence-gallery": "WE_DO",
      "energy-intro-video": "WE_DO",
      "energy-forms-pwo": "WE_DO",
      "battery-pwo": "WE_DO",
      "energy-pathway": "WE_DO",
      "system-energy-jobs": "WE_DO",
      "motor-energy-check": "YOU_DO",
      "motion-plan": "YOU_DO",
      "art-pattern-plan": "YOU_DO",
      "power-plan-evidence": "YOU_DO",
      "step4-saras": "YOU_DO",
      "step5-story": "I_DO",
      "circuit-images": "WE_DO",
      "circuit-first-prediction": "YOU_DO",
      "circuit-video": "WE_DO",
      "closed-switch-pwo": "WE_DO",
      "circuit-path-sequence": "WE_DO",
      "circuit-jobs": "WE_DO",
      "open-wire-check": "YOU_DO",
      "physical-circuit-checklist": "WE_DO",
      "circuit-evidence": "YOU_DO",
      "step5-saras": "YOU_DO",
      "step6-story": "I_DO",
      "wobble-images": "WE_DO",
      "balanced-offcenter-prediction": "YOU_DO",
      "dancing-robot-video": "WE_DO",
      "motor-animation-pwo": "WE_DO",
      "inertia-pwo": "WE_DO",
      "wobble-sequence": "WE_DO",
      "motion-causes": "WE_DO",
      "center-weight-check": "YOU_DO",
      "wobble-evidence": "YOU_DO",
      "step6-saras": "YOU_DO",
      "robot-understand-completion": "YOU_DO"
    },
    "robot-artist-apply": {
      "step7-story": "I_DO",
      "assembly-gallery": "I_DO",
      "assembly-video": "I_DO",
      "installation-pwo": "I_DO",
      "assembly-phase-checklist": "WE_DO",
      "launch-prediction": "YOU_DO",
      "first-test-record": "YOU_DO",
      "drawing-as-data": "YOU_DO",
      "mapping-wobble-video": "WE_DO",
      "step7-saras": "YOU_DO",
      "robot-apply-completion": "YOU_DO"
    },
    "robot-artist-test-improve": {
      "step8-story": "I_DO",
      "test1-case-file": "YOU_DO",
      "redesign-gallery": "WE_DO",
      "redesign-variable": "YOU_DO",
      "redesign-prediction": "YOU_DO",
      "redesign-video": "WE_DO",
      "wobble-power-video": "YOU_DO",
      "friction-station": "YOU_DO",
      "test2-record": "YOU_DO",
      "improvement-conclusion": "YOU_DO",
      "test-comparison": "YOU_DO",
      "step8-saras": "YOU_DO",
      "robot-test-improve-completion": "YOU_DO"
    },
    "robot-artist-explain": {
      "step9-story": "I_DO",
      "tests-summary": "YOU_DO",
      "system-gallery": "WE_DO",
      "energy-motion-sequence": "YOU_DO",
      "system-jobs": "YOU_DO",
      "imbalance-recap-video": "YOU_DO",
      "circuit-recap-video": "YOU_DO",
      "circuit-defense": "YOU_DO",
      "motion-defense": "YOU_DO",
      "final-science-explanation": "YOU_DO",
      "evidence-for-explanation": "YOU_DO",
      "step9-saras": "YOU_DO",
      "robot-explain-completion": "YOU_DO"
    },
    "robot-artist-reflect": {
      "robot-reflect-story": "I_DO",
      "final-case-summary": "YOU_DO",
      "final-reflection": "YOU_DO",
      "robot-reflect-completion": "YOU_DO"
    },
    "robot-artist-grow": {
      "step10-story": "I_DO",
      "gallery-images": "WE_DO",
      "robot-name": "YOU_DO",
      "artwork-title": "YOU_DO",
      "gallery-piece": "YOU_DO",
      "gallery-presentation": "YOU_DO",
      "engineers-defense": "YOU_DO",
      "completion-pwo": "YOU_DO",
      "step10-saras": "YOU_DO",
      "robot-grow-completion": "YOU_DO",
      "after-camp-robot-artist-mission": "YOU_DO",
      "after-camp-robot-artist-choice": "YOU_DO",
      "after-camp-robot-artist-plan": "YOU_DO",
      "after-camp-robot-artist-safety": "YOU_DO",
      "after-camp-robot-artist-trials": "YOU_DO",
      "after-camp-robot-artist-conclusion": "YOU_DO",
      "after-camp-robot-artist-saras": "YOU_DO"
    }
  }
};

const normalizeSlug = (value) => {
  const slug = String(value || "")
    .trim()
    .toLowerCase();

  return slug === "drawing-robot"
    ? "mystery-of-the-robot-artist"
    : slug;
};

const getModeSummary = (blockModes) => {
  const usedModes = new Set(Object.values(blockModes || {}));

  return [I_DO, WE_DO, YOU_DO].filter((mode) =>
    usedModes.has(mode)
  );
};

const getDefaultGrouping = (mode, blockType) => {
  if (mode === I_DO) return "whole_class";

  if (mode === WE_DO) {
    return [
      "build_checklist",
      "experiment_record",
      "multi_select",
    ].includes(blockType)
      ? "small_group"
      : "teacher_choice";
  }

  return ["build_checklist", "experiment_record"].includes(
    blockType
  )
    ? "small_group"
    : "teacher_choice";
};

const getDefaultTeacherCue = (mode) => {
  if (mode === I_DO) {
    return "Frame or model this part with a brief think-aloud. Preserve the question and do not complete the learner response.";
  }

  if (mode === WE_DO) {
    return "Guide one example or stage, ask learners to justify their thinking with evidence, and share responsibility for the task.";
  }

  return "Observe and ask evidence-focused questions. Support safety and access without supplying the learner's answer or conclusion.";
};

const getDefaultSelfGuidedCue = (mode, blockType) => {
  if (mode === I_DO) {
    if (["story_hook", "image_reveal"].includes(blockType)) {
      return "Professor Swan teaches this part first with a short model or think-aloud. Notice how the evidence is used before you make your own decision.";
    }

    if (["image_gallery", "video_asset", "pwo_asset", "local_video"].includes(blockType)) {
      return "Professor Swan teaches what to notice before you watch or explore. Then use the evidence yourself.";
    }

    return "Professor Swan teaches the thinking or procedure first. Your job is to notice the steps and how evidence is used.";
  }

  if (mode === WE_DO) {
    if (blockType === "build_checklist") {
      return "Work one build step at a time with Professor Swan. You handle the materials and complete each safety check yourself.";
    }

    if (blockType === "experiment_record") {
      return "Run the test while Professor Swan coaches the procedure. Record only what you actually observe.";
    }

    if (["video_asset", "pwo_asset", "local_video"].includes(blockType)) {
      return "Explore this with Professor Swan. Pause when needed and compare the model or video with your own evidence.";
    }

    if (["classification", "matching", "sequence_builder", "multi_select"].includes(blockType)) {
      return "Work through this with Professor Swan as your coach. Make each choice yourself and be ready to explain why.";
    }

    return "Work through this part with Professor Swan as your coach. You make the observations and choices; Professor Swan helps you reason.";
  }

  if (["choice_cards", "quiz_question", "multi_select"].includes(blockType)) {
    return "Your turn. Choose your own answer from the evidence. Ask Professor Swan for a hint only if you are stuck.";
  }

  if (blockType === "evidence_response") {
    return "Your turn. Explain the evidence in your own words. Professor Swan can question your reasoning, but should not write the answer for you.";
  }

  if (blockType === "experiment_record") {
    return "Your turn to run the trial and record exactly what happens. A surprising result is still useful evidence.";
  }

  if (blockType === "saras_checkpoint") {
    return "Ask Professor Swan to challenge your reasoning or give the smallest useful hint. Keep the final answer in your own words.";
  }

  if (blockType === "completion_gate") {
    return "Check your mission progress. Finish any missing evidence before you move on.";
  }

  if (blockType === "build_checklist") {
    return "Complete the build yourself, one safe step at a time. Ask a grown-up only when the safety note says adult help is needed.";
  }

  return "Your turn. Complete this part using your own observations and evidence, and ask Professor Swan for a hint if you get stuck.";
};

const getDefaultStudentCue = (mode, blockType) => {
  if (mode === I_DO) {
    if (["story_hook", "image_reveal"].includes(blockType)) {
      return "Listen and watch as the teacher introduces this part. Notice the important clues and constraints.";
    }

    if (
      ["image_gallery", "video_asset", "pwo_asset"].includes(
        blockType
      )
    ) {
      return "Watch how the teacher uses this evidence or tool before you apply it.";
    }

    return "Watch the teacher model the thinking or procedure for this part.";
  }

  if (mode === WE_DO) {
    if (blockType === "image_gallery") {
      return "Study the evidence together and explain what supports each idea.";
    }

    if (["video_asset", "pwo_asset", "local_video"].includes(blockType)) {
      return "Explore this together and pause to compare the model with the real system.";
    }

    if (
      ["classification", "matching", "sequence_builder"].includes(
        blockType
      )
    ) {
      return "Work through this together and justify each choice with evidence.";
    }

    if (blockType === "build_checklist") {
      return "Build one stage at a time with the teacher or team and complete each safety check.";
    }

    if (blockType === "multi_select") {
      return "Inspect and verify the items together before moving on.";
    }

    if (blockType === "experiment_record") {
      return "Run this teacher-guided test together and record what actually happens.";
    }

    if (blockType === "image_reveal") {
      return "Reveal and discuss the important clues together before choosing an explanation.";
    }

    return "Work through this part together and explain the evidence.";
  }

  if (["choice_cards", "quiz_question", "multi_select"].includes(blockType)) {
    return "Choose your answer using your own or your team's evidence.";
  }

  if (blockType === "evidence_response") {
    return "Explain this in your own words using evidence.";
  }

  if (blockType === "experiment_record") {
    return "Run the trial with your team and record what actually happens.";
  }

  if (
    ["sequence_builder", "matching", "classification"].includes(
      blockType
    )
  ) {
    return "Complete this using the evidence you have gathered, then check your reasoning.";
  }

  if (blockType === "prior_work_summary") {
    return "Review your saved evidence before deciding what to do next.";
  }

  if (blockType === "saras_checkpoint") {
    return "Use Saras to challenge your reasoning, then revise in your own words.";
  }

  if (blockType === "completion_gate") {
    return "Check your progress and finish any missing evidence.";
  }

  if (["video_asset", "pwo_asset", "local_video"].includes(blockType)) {
    return "Open this support when needed, then apply the evidence to your own work.";
  }

  if (blockType === "build_checklist") {
    return "Complete the build with your team, following the approved safety checks.";
  }

  if (blockType === "image_gallery") {
    return "Use the visual evidence to support your own conclusion.";
  }

  return "Complete this part using your own or your team's evidence.";
};

export const getJourneyInstructionalStepConfig = ({
  journeySlug,
  stepId,
}) => {
  const slug = normalizeSlug(journeySlug);
  const stepKey = String(stepId || "");

  return (
    JOURNEY_INSTRUCTIONAL_MODE_ASSIGNMENTS?.[slug]?.[
      stepKey
    ] || null
  );
};

export const applyJourneyInstructionalMetadata = ({
  journeySlug,
  stepId,
  page,
}) => {
  if (!page || typeof page !== "object") return page;

  const blockModes = getJourneyInstructionalStepConfig({
    journeySlug,
    stepId,
  });

  if (!blockModes) return page;

  const blocks = Array.isArray(page.blocks)
    ? page.blocks.map((block) => {
        const assignedMode = blockModes?.[block?.id];
        const mode = block?.instructional_mode || assignedMode;

        if (!mode) return block;

        return {
          ...block,
          instructional_mode: mode,
          grouping:
            block?.grouping ||
            getDefaultGrouping(mode, block?.type),
          teacher_cue:
            block?.teacher_cue ||
            getDefaultTeacherCue(mode),
          student_cue:
            block?.student_cue ||
            getDefaultStudentCue(mode, block?.type),
          self_guided_cue:
            block?.self_guided_cue ||
            getDefaultSelfGuidedCue(mode, block?.type),
        };
      })
    : page.blocks;

  const instructionalFlow =
    page?.instructional_flow ||
    {
      summary: getModeSummary(blockModes),
      teacher_goal:
        `Frame ${page?.title || "the step"}, guide shared evidence work, then release learners to complete and explain the task using their own or team evidence.`,
    };

  return {
    ...page,
    instructional_flow: instructionalFlow,
    blocks,
  };
};

export default applyJourneyInstructionalMetadata;
